/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserProfileDto } from '../models/UserProfileDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IdentityService {
  /**
   * @returns UserProfileDto OK
   * @throws ApiError
   */
  public static getUserProfile(): CancelablePromise<UserProfileDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/identity/profile',
    });
  }
}
